export class MissingRuntimeTriggerToken {}
